// extracted by mini-css-extract-plugin
export var bold = "_rf-0";